import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoRfidBadgeOrderListOrderNumberCell } from './emsp-bo-rfid-badge-order-list-order-number.cell';
import { EmspBoRfidBadgeOrderListOrderNumberHeader } from './emsp-bo-rfid-badge-order-list-order-number.header';

export const EmspBoRfidBadgeOrderListOrderNumberColumn: IdentifiedColumnDef<
  BackOfficeRfidBadgeOrderModel,
  BackOfficeRfidBadgeOrderModel['orderNumber']
> = {
  enableSorting: false,
  header: EmspBoRfidBadgeOrderListOrderNumberHeader,
  cell: EmspBoRfidBadgeOrderListOrderNumberCell,
};
